export default __webpack_public_path__ + "static/media/img3.508a66d6.jpg";